// Used on the FAQ page to create a drop down effect. 
// The question and answer classes are written for that context but can be applied elsewhere in the website
import { useState } from 'react';
import '../style/main.css';

// When clicked the accordion toggles the styling to show a drop down
function Accordion({ title, children }) {
    const [open, setOpen] = useState(false);
    return (
        <div class='accordion'>
            <button 
                class={`question ${open ? 'active' : ''}`} 
                onClick={() => setOpen(!open)}>
                <h4 class="question-title">
                    {title}
                    <span class="arrow">{open ? '▲' : '▼'}</span>
                </h4>
            </button>
            <div class={`answer ${open ? 'show' : ''}`}>
                    {children}
            </div>
            <br />
        </div>
    );
}

export default Accordion;